import axios from 'axios';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import _ from 'lodash';
import * as ActionTypes from './actionTypes';
import { NO_DATA } from '../../../../SharedModules/Errors/constantMessageData';

export const dispatchPlanType = (data) => ({
  type: ActionTypes.GET_PLAN_TYPE_DATA,
  payload: data,
});

export const setLoading = (value) => ({
  type: ActionTypes.IS_LOADING,
  isLoading: value,
});

export const setManufactureList = (data) => ({
  type: ActionTypes.SET_MANUFACTURERS_LIST_UNALLOACTED_BALANCE,
  payload: data,
});

export const setSearchInput = (data) => ({
  type: ActionTypes.SET_SELECTED_INPUT,
  payload: data,
});

export const setUnallocatedBalanceReports = (data, exportAll = false) => ({
  type: ActionTypes.GET_UNALLOCATED_BALANCE_REPORT,
  payload: data,
  exportAll,
});

export const refreshUnallocatedBalance = () => ({
  type: ActionTypes.REFRESH_UNALLOCATED,
  payload: {},
});

export const setPaginationIndex = (value) => ({
  type: ActionTypes.SET_PAGINATION_INDEX_UNALLOCATED,
  payload: value,
});

export const refreshUnallocatedBalanceDispaly = () => ({
  type: ActionTypes.REFRESH_UNALLOCATED_DETAIL,
  payload: {},
});

export const getPlanTypeValues = () => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.GET_COMMON_MANUFACUTRE_DROPDOWNS, {
      codeDomainList: ['PLAN_TYPE_CD'],
    })
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(dispatchPlanType(response.data));
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(dispatchPlanType([]));
    });
};
// This action show error message for 5 sec for no contract exists
const showNoDataMessage = () => (dispatch) => {
  // setTimeout(() => {
    // dispatch(setSearchInput({ errors: [] }));
  // }, 5000);
  dispatch(
    setSearchInput({
      errors: [
        {
          field: 'noData',
          message: NO_DATA,
        },
      ],
    })
  );
};
export const getManufacturerList = (values) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(serviceEndPoint.UNALLOCATED_BALANCE_MANUFACTURER_LIST, values)
    .then((response) => {
      dispatch(setLoading(false));
      return dispatch(
        setManufactureList(response?.data?.unallocatedBalanceMfgGridVO)
      );
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setManufactureList([]));
    });
};

export const getRebateProgrameList = (value) => (dispatch) => {
  dispatch(setLoading(true));
  return axios
    .post(`${serviceEndPoint.SYSTEM_LIST_ALL_DROPDOWN}`, { planType: value })
    .then((response) => {
      dispatch(setLoading(false));
      return response.data.data;
    })
    .catch((response) => {
      dispatch(setLoading(false));
    });
};

export const getUnallocatedBalanceReports = (values) => (dispatch) => {
  // if (values.asMfg.length === 1) {
  //   dispatch(setUnallocatedBalanceReports([]));
  // }
  dispatch(setLoading(true));

  return axios
    .post(serviceEndPoint.UNALLOCATED_BALANCE_REPORTS, values)
    .then((response) => {
      dispatch(setLoading(false));
      if (response?.data?.unallocatedBalanceReportVO.length === 0) {
        if (values.asMfg.length === 1) {
          dispatch(showNoDataMessage());
        }
        dispatch(
          setUnallocatedBalanceReports(
            response?.data?.unallocatedBalanceReportVO,
            values.asMfg.length > 1
          )
        );
      } else {
        dispatch(
          setUnallocatedBalanceReports(
            response?.data?.unallocatedBalanceReportVO,
            values.asMfg.length > 1
          )
        );
      }
      if (values.asMfg.length === 1) {
        dispatch(
          setUnallocatedBalanceReports(
            response?.data?.unallocatedBalanceReportVO,
            values.asMfg.length == 1
          )
        );
      }
    })
    .catch((response) => {
      dispatch(setLoading(false));
      dispatch(setUnallocatedBalanceReports([], values.asMfg.length > 1));
    });
};
